<template>
  <footer class="bg-putty relative z-10">
    <h2 class="sr-only">Footer</h2>
    <ClientOnly>
      <NewsletterSignupForm v-bind="{ ...newsletterSignup }" :global-fallback="true" />
    </ClientOnly>
    <BreadCrumb class="sm:hidden bg-white" />
    <ClientOnly>
      <GlobalUspBanner />
    </ClientOnly>
    <div class="bg-blackly text-white">
      <div class="gap-y-8 container grid py-10">
        <FooterNav :nav="footerNav" />
        <div class="md:grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-8 md:text-left grid text-center">
          <PaymentMethods :payment-methods="paymentMethods" />
          <LogisticPartners :logistic-partners="logisticPartners" />
          <div>
            <h3 class="fluid-xs leading-snug uppercase font-medium mb-4">
              {{ $t('navigation.downloadOurApp') }}
            </h3>
            <AppStoreLinks />
          </div>
          <SocialMediaAccounts :social-media-accounts="socialMediaAccounts" />
        </div>
      </div>
    </div>
    <div class="md:flex container justify-between py-8">
      <div
        v-show="hasAlternates"
        class="fluid-xs leading-snug uppercase font-medium md:order-1 md:justify-end md:mb-0 flex items-center justify-center mb-2"
      >
        <RegionAndLanguageIndicator class="ml-1" />
      </div>
      <LegalNav class="text-blackly" :legal-nav="legalNav" />
    </div>
  </footer>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useAppStore } from '@/stores/app';
import { useMainNavStore } from '@/stores/main-nav';
import BreadCrumb from '@/components/layout/BreadCrumb';
import FooterNav from '@/components/layout/footer/FooterNav';
import PaymentMethods from '@/components/layout/footer/PaymentMethods';
import LogisticPartners from '@/components/layout/footer/LogisticPartners';
import SocialMediaAccounts from '@/components/layout/footer/SocialMediaAccounts';
import LegalNav from '@/components/layout/footer/LegalNav';
import GlobalUspBanner from '@/components/layout/GlobalUspBanner';
import NewsletterSignupForm from '@/components/common/blocks/NewsletterSignupForm';
import RegionAndLanguageIndicator from '@/components/layout/header/RegionAndLanguageIndicator';
import AppStoreLinks from '@/components/common/AppStoreLinks';

const appStore = useAppStore();
const mainNavStore = useMainNavStore();

const currentlyOpenPopover = ref(null);

// Get all footer data from store
const footerNav = computed(() => appStore.footerData.footerNav);
const paymentMethods = computed(() => appStore.footerData.paymentMethods);
const logisticPartners = computed(() => appStore.footerData.logisticPartners);
const socialMediaAccounts = computed(() => appStore.footerData.socialMediaAccounts);
const legalNav = computed(() => appStore.footerData.legalNav);
const newsletterSignup = computed(() => appStore.footerData.newsletterSignup);

const hasAlternates = computed(() => mainNavStore.hasAlternates);

function togglePopover(popoverName) {
  if (currentlyOpenPopover.value === popoverName) {
    currentlyOpenPopover.value = null;
  } else {
    currentlyOpenPopover.value = popoverName;
  }
}

function closePopover() {
  currentlyOpenPopover.value = null;
}
</script>
